<template>
  <router-view />
</template>

<script>
// @ is an alias to /src
// import NavBar from "@/components/NavBar.vue";

export default {
  name: "HomeView",
  components: {},
};
</script>

<style lang="scss">
@import "styles/custom.scss";

@import "bootstrap/scss/bootstrap.scss";
// @import '~bootstrap-vue/src/index.scss';

html,
body {
  height: 100%;
  margin: 0;
}

body {
  background-color: #f6f7f8;
}
html {
  font-weight: 400;
  background-color: #f6f7f8;
}

#app {
  min-height: 100vh;
}

.btn-secondary {
  font-weight: 700;
}
</style>
